<template>
	<OneOnOneListCardLayout
		:class="classes"
		@click="$emit( `navTo`, { id: oneOnOne.id, } )"
	>
		<template v-slot:favorite>
			<ToggleStar
				v-if="!oneOnOne.archived"
				:is-toggled="!!oneOnOne.isFavorited"
				@change="onStarClicked"
			/>
		</template>
		<template v-slot:name>
			<div class="one-on-one-list-card__member" v-tooltip.top="otherMemberName">
				<UserAvatar
					:user="otherMember"
					size="1.5rem"
				/>
				<div class="one-on-one-list-card__name">{{ otherMemberName }}</div>
			</div>
		</template>
		<template v-slot:status>
			<TeamingChip
				v-if="oneOnOne.isTeamingTeam"
				class="one-on-one-list-card__sample-chip"
				@click="$emit( `navTo`, { id: oneOnOne.id, } )"
			>
				<template v-slot:text>
					<span class="one-on-one-list-card__sample-chip-text">{{ $t( "common.OneOnOneListCard_sampleChipLabel" ) }}</span>
				</template>
			</TeamingChip>
			<span v-else :class="otherMemberStatusClass">{{ otherMemberStatus }}</span>
		</template>
		<template v-slot:role>
			{{ otherMemberRole }}
		</template>
		<template v-slot:chevron>
			<FontAwesomeIcon
				class="one-on-one-list-card__chevron"
				:icon="[ 'fas', 'chevron-right' ]"
			/>
		</template>
	</OneOnOneListCardLayout>
</template>

<script>
import OneOnOneListCardLayout from "./OneOnOneListCardLayout";
import ToggleStar from "../ToggleStar";
import UserAvatar from "../UserAvatar";
import TeamingChip from "../TeamingChip";

export default {
	name: "OneOnOneListCard",
	emits: [
		"favorite",
		"unfavorite",
		"navTo",
	],
	components: {
		OneOnOneListCardLayout,
		TeamingChip,
		ToggleStar,
		UserAvatar,
	},
	props: {
		className: {
			type: String,
			default: "",
		},
		oneOnOne: {
			type: Object,
			required: true,
			validator( oneOnOne ) {
				return ( oneOnOne.id && oneOnOne.otherMember );
			},
		},
	},
	computed: {
		classes() {
			return {
				"one-on-one-list-card": true,
				"one-on-one-list-card--is-sample-team": !!this.oneOnOne?.isTeamingTeam,
				[ this.className ]: !!this.className,
			};
		},
		otherMemberStatusClass() {
			const { otherMember, } = this;
			if ( !otherMember ) {
				return "";
			}
			return `one-on-one-list-card__status--${ otherMember.status }`;
		},
		otherMember() {
			return this.oneOnOne.otherMember;
		},
		otherMemberName() {
			return this.otherMember.displayName;
		},
		otherMemberStatus() {
			const { status, } = this.otherMember;
			if ( !status ) {
				return "";
			}
			return this.$t( `common.OneOnOneListCard_teamMemberStatusType${ status }` );
		},
		otherMemberRole() {
			const { role, } = this.otherMember;
			if ( !role ) {
				return "";
			}
			return this.$t( `common.OneOnOneListCard_teamRoleType${ role }` );
		},
	},
	methods: {
		onStarClicked( e ) {
			if ( this.oneOnOne.archived ) {
				return;
			}
			const eventName = e.isToggled ? "favorite" : "unfavorite";
			this.$emit( eventName, { id: this.oneOnOne.id, } );
		},
	},
};
</script>

<style lang="scss" scoped>
.one-on-one-list-card {
	border-color: $one-on-one-list-card-border-color;
	box-shadow: 0 0.0625rem 0.25rem rgba(42, 47, 69, 0.1);
	cursor: pointer;
}

.one-on-one-list-card__member {
	display: inline-flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
}

.one-on-one-list-card__name {
	padding-left: 1rem;
	font-weight: 600;
	color: $one-on-one-list-card-name-color;

	text-overflow: ellipsis;
	overflow: hidden;
	line-height: 1.3rem;
	white-space: nowrap;
}

.one-on-one-list-card__sample-chip {
	@include font-and-line-for(0);
	text-transform: uppercase;
	color: $one-on-one-list-card-sample-chip-font-color;
	background: $one-on-one-list-card-sample-chip-bg-color;
	border-radius: 1.5rem;
	font-weight: 600;
}

.one-on-one-list-card__sample-chip-text {
	padding: 0 .25rem 0 .25rem;
}

.one-on-one-list-card__chevron {
	color: $one-on-one-list-card-chevron-color;
}

.one-on-one-list-card__status--DEFERRED {
	color: $one-one-one-list-card-deferred-status-color;
}
</style>
